import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  markAsReadText: {
    color: 'inherit'
  },

  popover: {
    '&.ant-popover-open .ant-btn': {
      color: token.colorInfo,
      borderColor: token.colorInfo
    }
  },

  popOverNotifications: {
    '.ant-popover-inner': {
      width: 400
    }
  },

  titleHeaderPopover: {
    marginInline: token.marginSM
  },

  badge: {
    display: 'flex',
    alignItems: 'center'
  }
}))
